
import {useEffect, useMemo, useState} from "react";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import SubscriptionService from "../../../services/subscription.service";
import {toast} from "react-toastify";
import {useLocation} from "react-router-dom";
import {getAppPath} from "../../../services/app-path.service";



import tick from "assets/images/tick-green-icon.png";
import cross from "assets/images/cross.jpg";

function AfterPayment() {
    const [waiting, setWaiting] = useState(false);
    const [processedSuccessfully, setProcessedSuccessfully] = useState(false);
    const [resultMessage, setResultMessage] = useState("");
    const search = useLocation().search;
    const paymentResult = useMemo(() => {
        const params = new URLSearchParams(search);
        const getParam = (key) => (params.get(key) || "").replace(/\s/g, "+");

        return {
            status: getParam("status"),
            product: getParam("product"),
            redirectStatus: getParam("redirect_status"),
            setupIntent: getParam("setup_intent") || getParam("payment_intent"),
            setupIntentClientSecret: getParam("setup_intent_client_secret") || getParam("payment_intent_client_secret"),
        };
    }, [search]);
    const hasPaymentResult = Boolean(paymentResult.product && paymentResult.status && paymentResult.setupIntent && paymentResult.setupIntentClientSecret);
    const isSuccess = processedSuccessfully || paymentResult.redirectStatus === "succeeded";

    useEffect(() => {
        if (!hasPaymentResult) {
            setWaiting(false);
            setProcessedSuccessfully(false);
            setResultMessage("Payment confirmation details are incomplete. Please retry plan checkout.");
            return;
        }

        setWaiting(true);
        setProcessedSuccessfully(false);
        setResultMessage("");

        const values = {
            product: paymentResult.product,
            status: paymentResult.status,
            setup_intent: paymentResult.setupIntent,
            setup_intent_client_secret: paymentResult.setupIntentClientSecret,
            redirect_status: paymentResult.redirectStatus,
        };

        SubscriptionService.processPayment(values)
            .then(() => {
                setWaiting(false);
                setProcessedSuccessfully(true);
                localStorage.setItem("has_plan", "1");
                localStorage.setItem("active_plan", paymentResult.product);
                toast.success("Process Completed", {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
            }).catch((e) => {
                const message = e?.response?.data?.status || "Could not complete payment processing";
                setWaiting(false);
                setProcessedSuccessfully(false);
                setResultMessage(message);
                toast.error(message, {position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000, hideProgressBar: false});
            });
    }, [hasPaymentResult, paymentResult]);


    const handleAgreeDialog = () => {
        if (!waiting){
            const nextPath = hasPaymentResult && isSuccess ? "/dashboards/payments" : "/dashboards/pricing";
            setTimeout(function () {window.location.href = getAppPath(nextPath)}, 1000)
        }
    }

    return (<DashboardLayout>
            <SoftBox pt={3} pb={8} variant={"contained"}  sx={{"textAlign":"center","marginTop":"10rem"}}>
                <SoftBox component="img" src={isSuccess ? tick : cross} alt={"RBR"} height="100px" borderRadius="lg" />
                <br/>
                <br/>
                <SoftTypography sx={{"marginBottom":"2rem"}} variant="h2" color={"text"} fontWeight={"bold"} textGradient={true} opacity={0.7} >
                    {(paymentResult.redirectStatus || "unknown").toUpperCase()} Payment
                </SoftTypography>
                <br/>
                <SoftTypography sx={{"marginBottom":"2rem"}} variant="h4" color={"primary"} fontWeight={"bold"} textGradient={true} opacity={0.7} >
                    Your Payment Code : {paymentResult.setupIntent || "-"}
                </SoftTypography>

                <br/>

                <SoftTypography sx={{"marginBottom":"2rem", "display": waiting ? "block" : "none"  }}  variant="h6" color={"dark"} fontWeight={"bold"} textGradient={true} opacity={0.7} >Processing Your Subscriptions...</SoftTypography>
                <SoftTypography sx={{"marginBottom":"2rem", "display": resultMessage ? "block" : "none"  }} variant="h6" color={"error"} fontWeight={"bold"}>
                    {resultMessage}
                </SoftTypography>
                <br/>
                <SoftButton color={"dark"} size={"large"} onClick={handleAgreeDialog} disabled={waiting}>
                    {hasPaymentResult && isSuccess ? "GoTo My Payment Page" : "Back To Pricing"}
                </SoftButton>

            </SoftBox>
        </DashboardLayout>)
}

export default AfterPayment;
